import React from "react";
import { Question } from "../../types";
import { getSjtCorrectOrderIds } from "./sjtUtils";

type SjtOrderPanelProps = {
  question: Question;
  practiceQuestionAnswered: boolean;
  selection: number[];
  initialLetterByAnswerId: { [key: number]: string };
};

export const SjtOrderPanel: React.FC<SjtOrderPanelProps> = ({
  question,
  practiceQuestionAnswered,
  selection,
  initialLetterByAnswerId,
}) => {
  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      {selection.length > 0 ? (
        <div style={{ marginBottom: 8 }}>
          <div style={{ color: "#444", marginBottom: 6 }}>Selected order</div>
          <div style={{ display: "inline-flex", flexWrap: "wrap", gap: 8 }}>
            {selection.map((id, idx) => {
              const correctOrder = getSjtCorrectOrderIds(question) || [];
              const isCorrectPosition = practiceQuestionAnswered && correctOrder[idx] === id;
              const backgroundColor = practiceQuestionAnswered
                ? isCorrectPosition
                  ? "rgba(0, 160, 0, 0.16)"
                  : "rgba(220, 0, 0, 0.16)"
                : undefined;
              const borderColor = practiceQuestionAnswered
                ? (isCorrectPosition ? "#009000" : "#cc0000")
                : "#e0e0e0";
              return (
                <div
                  key={id}
                  style={{
                    minWidth: 28,
                    height: 28,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: `1px solid ${borderColor}`,
                    borderRadius: 6,
                    fontWeight: 500,
                    lineHeight: 1,
                    backgroundColor,
                  }}
                >
                  {initialLetterByAnswerId[id]}
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
      {practiceQuestionAnswered ? (
        <div>
          <div style={{ color: "#444", marginBottom: 6 }}>Correct order</div>
          <div style={{ display: "inline-flex", flexWrap: "wrap", gap: 8 }}>
            {(getSjtCorrectOrderIds(question) || []).map((id) => (
              <div
                key={id}
                style={{
                  minWidth: 28,
                  height: 28,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid #e0e0e0",
                  borderRadius: 6,
                  fontWeight: 500,
                  lineHeight: 1,
                }}
              >
                {initialLetterByAnswerId[id]}
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};


